import React from 'react';
import {Casing} from '~/common/fabric/CreateDesign/components/CardEditor/actions/TextFormat/components/Casing/Casing';
import {Alignment} from '~/common/fabric/CreateDesign/components/CardEditor/actions/TextFormat/components/Alignment/Alignment';

import './TextFormat.sass';

export const TextFormat = () => (
  <div className="text_format">
    <Casing className="text_format__upper" />
    <Alignment className="text_format__lower" />
  </div>
);
